document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-promo-gallery]').forEach((gallery) => {
    const promoDialog = gallery.querySelector('[data-promo-dialog]');
    if (!promoDialog) return;

    const promoDialogImage = promoDialog.querySelector('[data-promo-dialog-image]');
    let activeTrigger = null;

    gallery.addEventListener('click', (event) => {
      const openButton = event.target.closest?.('[data-promo-open]');
      if (openButton) {
        const triggerGallery = openButton.closest('[data-promo-gallery]');
        const triggerDialog = triggerGallery?.querySelector('[data-promo-dialog]');
        if (triggerGallery !== gallery || triggerDialog !== promoDialog || !promoDialogImage) return;

        activeTrigger = openButton;
        promoDialogImage.src = openButton.dataset.promoSrc || '';
        promoDialogImage.alt = openButton.dataset.promoAlt || '';
        promoDialog.showModal();
        return;
      }

      const closeButton = event.target.closest?.('[data-promo-close]');
      if (closeButton?.closest('[data-promo-gallery]') === gallery) promoDialog.close();
    });

    promoDialog.addEventListener('click', (event) => {
      if (event.target === promoDialog) promoDialog.close();
    });

    promoDialog.addEventListener('close', () => {
      activeTrigger?.focus();
      activeTrigger = null;
    });
  });

  const container = document.querySelector('[data-b2b-inquiry-form]');
  const form = container?.querySelector('form');
  if (!form) return;

  const params = new URLSearchParams(window.location.search);
  const mapping = {
    product: 'Product',
    sku: 'SKU',
    url: 'Product URL',
    category: 'Product Category',
    variant: 'Variant',
    color: 'Required Color',
  };

  Object.entries(mapping).forEach(([parameter, field]) => {
    const input = form.elements[`contact[${field}]`];
    const value = params.get(parameter);
    if (input && value) input.value = value;
  });

  const promotionalCode = params.get('promo')?.trim().toUpperCase() || '';
  if (/^PI-(0[1-9]|1[0-2])$/.test(promotionalCode)) {
    const productInput = form.elements['contact[Product]'];
    const categoryInput = form.elements['contact[Product Category]'];
    if (productInput) productInput.value = promotionalCode;
    if (categoryInput) categoryInput.value = 'Promotional Items';
  }
});
